import styled from '../../../../config/theme'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  > div {
    width: calc(50% - 5px);
    margin-bottom: 10px;

    &:nth-child(even) {
      margin-left: 5px;
    }
    &:nth-child(odd) {
      margin-right: 5px;
    }

    @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
      width: 100%;
      margin-right: 0 !important;
      margin-left: 0 !important;
      margin-bottom: 10px;
    }
  }
`

export {
  Container,
}
